import { TextEditor as TinyMCEEditor, tinyMCE } from '@procore/core-react'
import React, { useMemo } from 'react'
import { sanitizeTextEditorHtml } from '../TextEditorOutput/TextEditorOutput.utils'
import { StyledReadOnlyValue } from './TextEditor.styles'
import type { TextEditorProps } from './TextEditor.types'

export const TinyMCETextEditor = (props: TextEditorProps) => {
  const {
    id,
    value,
    disabled,
    error,
    readonly,
    placeholder,
    rows,
    extendable,
    onChange,
    onBlur,
    onFocus,
    onKeyDown,
    init,
  } = props

  const baseHeight = 74
  const rowHeight = 22
  const height = rows === undefined ? undefined : rows * rowHeight + baseHeight

  const sanitizedValue = useMemo(
    () => sanitizeTextEditorHtml(value || '') || '--',
    [value]
  )

  if (readonly) {
    return (
      <StyledReadOnlyValue>
        <div dangerouslySetInnerHTML={{ __html: sanitizedValue }} />
      </StyledReadOnlyValue>
    )
  }

  return (
    <TinyMCEEditor
      id={id}
      value={value}
      disabled={disabled}
      error={error}
      aria-label={props['aria-label']}
      textareaName={props['aria-label']}
      plugins={[...tinyMCE.defaultPlugins, 'link', 'table']}
      init={{
        contextmenu: false,
        min_height: height,
        max_height: extendable ? undefined : height,
        placeholder,
        ...init,
      }}
      onChange={onChange}
      onBlur={onBlur as React.ComponentProps<typeof TinyMCEEditor>['onBlur']}
      onFocus={onFocus as React.ComponentProps<typeof TinyMCEEditor>['onFocus']}
      onKeyDown={
        onKeyDown as React.ComponentProps<typeof TinyMCEEditor>['onKeyDown']
      }
    />
  )
}
